// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__fWVCu","ldioYc6vm4251k9":"spinner_ldioYc6vm4251k9__ueKvO","loadingioSpinnerSpinner6l6y7wnc6vp":"spinner_loadingioSpinnerSpinner6l6y7wnc6vp__jmxXQ"};